import { render, staticRenderFns } from "./AdvancedAppointment.vue?vue&type=template&id=671163a4&scoped=true"
import script from "./AdvancedAppointment.vue?vue&type=script&lang=js"
export * from "./AdvancedAppointment.vue?vue&type=script&lang=js"
import style0 from "./AdvancedAppointment.vue?vue&type=style&index=0&id=671163a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671163a4",
  null
  
)

export default component.exports